import React from 'react';
import { Header, Footer, Socials} from '../components';

const About = () => {
    return (
        <>
            <Header/>
            <main>

            </main>
            <Footer />
            <Socials />
        </>
    );
}

export default About;